import { useAuth0 } from "@auth0/auth0-react";
import Loader from "components/loader/Loader";
import Selection from "components/Selection/Selection";
import EventTaskSkelton from 'components/Skelton/PastoralSkelton/EventTaskSkelton';
import PastoralService from 'Lib/API/PastoralApi/index';
import React, { useEffect, useRef, useState } from 'react';
import InfiniteScroll from "react-infinite-scroll-component";
import { toastr } from "react-redux-toastr";
import EventCard from '../eventCard/EventCard';
import "./index.scss";




const EventsList = ({ handelEventDrawer,selectedEvent,callEventsAgain,eventTypes,getEventTypesLoading }) => {
  const eventsRef = useRef(null);
  const { getAccessTokenSilently } = useAuth0();
  const [totalValue, setTotalValue] = useState(0);
  const [loading, setLoading] = useState(true);
  const [eventList, setEventList] = useState([]);
  const [page, setPage] = useState(1);
  const [selectedEventType, setSelectedEventType] = useState(null);

  const fetchMyAPI = async (initialPage) => {
    setLoading(true);
    const currentPage = initialPage || page;
    const token = await getAccessTokenSilently();
    PastoralService.getPastoralEvents({ token, page: currentPage, limit: 10 })
      .then((res) => {
        if (res) {
          setEventList(res?.events);
          setTotalValue(res?.total);

          setPage((prevPage) => prevPage + 1);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setLoading(false);
      });
  };



  React.useEffect(() => {
    if(eventsRef?.current) {
			eventsRef.current.scrollTop = 0;
		}
    fetchMyAPI(1);
  }, [callEventsAgain]);

  const options =
    eventTypes &&
    eventTypes?.map((item) => {
      return {
        label: item?.name,
        typeId: item?.id,
      };
    });


    useEffect(() => {
      if(!selectedEventType?.typeId) return;
      handelEventDrawer(selectedEventType);
    }, [selectedEventType]);


    useEffect(() => {
      if(selectedEvent?.typeId) return;
      setSelectedEventType(null);
    }, [selectedEvent]);

  return (

    <div className="pastoral__event-list w-100">
      <div className="pastoral__event-list-h d-flex justify-content-between align-items-center mb-5">
        <div className="d-flex align-items-center">
          <p className="m-0 font-16">Events</p>
        </div>
      </div>
      <div className="form-group event-type-newEvent w-100">
        <Selection
          name="eventType"
          mandatory={true}
          placeholder="Select Event Type" 
          options={options}
          isLoading={getEventTypesLoading}
          onChange={(value) => {
            if (!value) {
              setSelectedEventType(null);
              return;
            }
            setSelectedEventType({
              typeId: value.typeId,
              name: value.label,
            })
          }}
          value={selectedEventType ? {
            label: selectedEventType?.name,
            typeId: selectedEventType?.typeId,
          } : null}
          isClearable={selectedEventType}
        />
      </div>
      <div className="">
        <div className="pastoral__event-list-scroll pr-3" id="events-wrapper" ref={eventsRef}>
          {totalValue === 0 && !loading && <h3 className="text-center mt-5">No Data</h3>}
          {(loading && totalValue === 0) ? (
            <>
              {[...Array(5)].map((item, index) => (
                <EventTaskSkelton />
              ))}
            </>
          ) :
            eventList !== null && eventList?.length > 0 && (
              <div className="tasks-body">
                <InfiniteScroll
                  scrollableTarget="events-wrapper"
                  dataLength={eventList.length}
                  next={fetchMyAPI}
                  hasMore={eventList?.length < totalValue}
                  loader={
                    <EventTaskSkelton />
                  }
                >
                  {eventList?.map((item) => {
                    return (
                      <EventCard
                        key={item.typeId}
                        loading={loading}
                        membersData={item.members}
                        name={item.name}
                        numberOfMembers={item.members.length}
                        onclick={() => handelEventDrawer(item)}
                      />
                    );
                  })}
                </InfiniteScroll>
              </div>
            )}

        </div>
      </div>
    </div>

  )
}

export default EventsList